<script setup lang="ts">
  import { inject, onBeforeMount, ref, useSlots } from 'vue';

  import { MODULE_INJECTION } from '../Module/Module.keys';
  import { ModuleVariant } from '../Module/Module.types';

  defineOptions({
    name: 'll-module-content',
  });

  const slots = useSlots();
  const moduleVariant = ref();

  onBeforeMount(() => {
    const moduleInjectedValues = inject(MODULE_INJECTION.key, MODULE_INJECTION.defaults);
    if (!moduleInjectedValues.variant) {
      throw new Error('ModuleContent must be used within a Module component.');
    }
    moduleVariant.value = moduleInjectedValues.variant.value;
  });
</script>

<template>
  <div
    class="stash-module-content flex-1"
    data-test="stash-module-content"
    :class="{
      'px-3 py-6 lg:px-6': moduleVariant === ModuleVariant.Card,
      'border-t border-ice-200': moduleVariant === ModuleVariant.Table || moduleVariant === ModuleVariant.List,
    }"
  >
    <div
      v-if="slots['top-left'] || slots['top-right']"
      class="stash-module-content__top-slots flex flex-wrap items-center justify-between"
      data-test="stash-module-content|top-slots"
    >
      <!--
        For styling purposes, we always render both slots. In the scenario where only a top-right is
        provided, the div wrappers ensure space-between works and puts top-right on the right side.
      -->
      <div class="mb-6 mr-6" data-test="stash-module-content|top-left-slot"><slot name="top-left"></slot></div>
      <div class="mb-6" data-test="stash-module-content|top-right-slot"><slot name="top-right"></slot></div>
    </div>

    <slot></slot>
  </div>
</template>
